import TranslationsContext from './TranslationsContext';
import DOMPurify from "dompurify";

const Translate = ({ string }) => {
	return <TranslationsContext.Consumer>{
		({ __ }) => {
			return __(string, 'wp-sync-for-notion');
		}
	}</TranslationsContext.Consumer>
}


export const TranslateHTML = ({ string, allowedHTMLTags = [], allowedHTMLAttrs = [], ...props }) => {
	return <div { ...props } dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(string, { ALLOWED_TAGS: allowedHTMLTags, ALLOWED_ATTR: allowedHTMLAttrs }) }} />;
}

/**
 * Fake function for "wp i18n" WP Cli command to find strings.
 */
export const __ = (string) => {
	return <Translate string={ string } />;
}

export default Translate;
